import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import React from "react"
import Grid from "@mui/material/Grid"
import { Step6Props } from "../types"
import { Divider, FormLabel, Typography, Button, CircularProgress, Alert } from "@mui/material"
import FormItem from "../../../hoc/FormItem"
import useStyles from "../styles/Step6.styles"
import { ReactionTypeDesc } from "../../Step4/constants"
import { useGtmPageView } from "../../hooks"

const Step6View: React.FC<Step6Props> = ({ dataProps, onSubmit, onStepBack, isUpdating, note, handleSetNote }) => {
    const classes = useStyles()
    useGtmPageView({ pageName: "Step6" })

    return (
        <Box p={2} maxWidth={"1050px"}>
            <Box p={1}>
                <Typography fontSize={{ xs: "1.2rem", sm: "1.973rem" }} variant="h4">
                    SOUHRN
                </Typography>
            </Box>
            <Box p={1}>
                <Typography variant="body1" paragraph>
                    Máme od Vás vše potřebné k zahájení střežení. Prosíme o finální kontrolu a potvrzení Vámi vyplněných údajů.
                </Typography>
            </Box>
            <Box mb={2}>
                <Alert severity="success">
                    <Typography>Nyní získáváte službu Celková ochrana na 3 měsíce zdarma, která obsahuje:</Typography>
                    <Typography className={classes.list} component="ul">
                        <li>Nepřetržité střežení Bezpečnostním Centrem JABLOTRON</li>
                        <li>Výjezd zásahovou jednotkou – zdarma</li>
                        <li>Možnost předání klíčů ke kontrole objektu</li>
                        <li>Přístup do aplikace MyJABLOTRON umožňující dálkovou kontrolu alarmu a jeho ovládání</li>
                    </Typography>
                </Alert>
            </Box>
            <Divider />
            <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={4} paddingLeft={2} paddingTop={2}>
                <Box marginBottom={2}>
                    <Typography variant="h5">Základní informace</Typography>
                </Box>
                <Grid container spacing={{ xs: 1, md: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 1, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Zákazník</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        id="name"
                                        fullWidth
                                        aria-readonly
                                        value={dataProps.personName}
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Grid className={classes.longLabelText} container spacing={{ xs: 1, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem marginTop={{ xs: "10px", md: 0 }}>
                                    <FormLabel className={classes.formLabelBlock}>Právní forma</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        aria-readonly
                                        variant="outlined"
                                        value={dataProps.personTypeText}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 1, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Druh oprávnění</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                        aria-readonly
                                        value={dataProps.permissionTypeText}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 1, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Telefonní číslo</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        value={dataProps.personPhoneNumber}
                                        aria-readonly
                                        variant="outlined"
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 1, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>E-mailová adresa</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        aria-readonly
                                        variant="outlined"
                                        value={dataProps.personEmail}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6} height={{ xs: 0, md: "auto" }}>
                        {/* TODO: remove style opacity when needed */}
                        <Grid className={classes.longLabelText} style={{ opacity: 0 }} container spacing={{ xs: 1, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem marginTop={{ xs: "10px", md: 0 }}>
                                    <FormLabel className={classes.formLabelBlock}>Nastavení z jiné smlouvy</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        aria-readonly
                                        variant="outlined"
                                        value={dataProps.useSettingsAnotherContractText}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {dataProps.useSettingsAnotherContract && (
                <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={4} paddingLeft={2} paddingTop={2}>
                    <Box>
                        <Typography variant="h6">Smlouva</Typography>
                    </Box>
                    <Grid container spacing={{ xs: 0, md: 2 }}>
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={{ xs: 1, md: 0 }}>
                                <Grid item xs={12} md={4}>
                                    <FormItem>
                                        <FormLabel className={classes.formLabelBlock}>Smlouva</FormLabel>
                                    </FormItem>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <FormItem>
                                        <TextField
                                            fullWidth
                                            label=""
                                            className={classes.readOnly}
                                            aria-readonly
                                            variant="outlined"
                                            value={dataProps.numberAnotherContract}
                                        />
                                    </FormItem>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={{ xs: 1, md: 0 }}>
                                <Grid item xs={12} md={4}>
                                    <FormItem>
                                        <FormLabel className={classes.formLabelBlock}>Sjednocení fakturace</FormLabel>
                                    </FormItem>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <FormItem>
                                        <TextField
                                            fullWidth
                                            label=""
                                            className={classes.readOnly}
                                            aria-readonly
                                            variant="outlined"
                                            value={dataProps.unifyInvoicingText}
                                        />
                                    </FormItem>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}

            <Divider />
            <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={4} paddingLeft={2} paddingTop={2}>
                <Box marginBottom={2}>
                    <Typography variant="h5">Identifikace objektu</Typography>
                </Box>
                <Grid container spacing={{ xs: 1, md: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>PSČ</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        id="zip"
                                        fullWidth
                                        aria-readonly
                                        value={dataProps.objectZIP}
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Město</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        aria-readonly
                                        variant="outlined"
                                        value={dataProps.objectCity}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Ulice</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                        aria-readonly
                                        value={dataProps.addressFormatted}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem marginTop={{ xs: "10px", md: 0 }}>
                                    <FormLabel className={classes.formLabelBlock}>GPS středu objektu</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        aria-readonly
                                        variant="outlined"
                                        value={dataProps.objectGPSLatitude}
                                    />
                                </FormItem>
                            </Grid>
                            <Grid item xs={6} md={4}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        aria-readonly
                                        variant="outlined"
                                        value={dataProps.objectGPSLongitude}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid className={classes.longLabelText} container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem marginTop={{ xs: "10px", md: 0 }}>
                                    <FormLabel className={classes.formLabelBlock}>Garantovaný čas dojezdu</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                        aria-readonly
                                        value={dataProps.guaranteedArrivalTime}
                                        InputProps={{
                                            endAdornment: <span>min.</span>,
                                        }}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Typ objektu</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        aria-readonly
                                        variant="outlined"
                                        value={dataProps.objecTypeText}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Popis objektu</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                        aria-readonly
                                        value={dataProps.objectDesription}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    {dataProps.personType === "Legal" && (
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={{ xs: 0, md: 0 }}>
                                <Grid item xs={12} md={4}>
                                    <FormItem>
                                        <FormLabel className={classes.formLabelBlock}>Velikost objektu</FormLabel>
                                    </FormItem>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <FormItem>
                                        <TextField
                                            fullWidth
                                            label=""
                                            className={classes.readOnly}
                                            aria-readonly
                                            variant="outlined"
                                            value={dataProps.objectSizeText}
                                        />
                                    </FormItem>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>
            <Divider />
            <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={4} paddingLeft={2} paddingTop={2}>
                <Box marginBottom={2}>
                    <Typography variant="h5">Kontrola objektu</Typography>
                </Box>
                <Grid container spacing={{ xs: 1, md: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Pes na objektu</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        id="name"
                                        fullWidth
                                        aria-readonly
                                        value={dataProps.locationDogText}
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Grid className={classes.longLabelText} container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem marginTop={{ xs: "10px", md: 0 }}>
                                    <FormLabel className={classes.formLabelBlock}>Přístupové prostředky</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        aria-readonly
                                        variant="outlined"
                                        value={dataProps.handoverKeysText}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Typ kontroly objektu</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                        aria-readonly
                                        value={dataProps.controlTypeText}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Kontrolní čipy</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        aria-readonly
                                        variant="outlined"
                                        value={dataProps.setControlChipsText}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    {dataProps.showChipping && (
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={{ xs: 0, md: 0 }}>
                                <Grid item xs={12} md={4}>
                                    <FormItem>
                                        <FormLabel className={classes.formLabelBlock}>Přítomnost u prohlídky</FormLabel>
                                    </FormItem>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <FormItem>
                                        <TextField
                                            fullWidth
                                            label=""
                                            className={classes.readOnly}
                                            variant="outlined"
                                            aria-readonly
                                            value={dataProps.customerPresenceText}
                                        />
                                    </FormItem>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    {dataProps.showChipping && (
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={{ xs: 0, md: 0 }}>
                                <Grid item xs={12} md={4}>
                                    <FormItem>
                                        <FormLabel className={classes.formLabelBlock}>Termín prohlídky</FormLabel>
                                    </FormItem>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <FormItem>
                                        <TextField
                                            fullWidth
                                            label=""
                                            className={classes.readOnly}
                                            aria-readonly
                                            variant="outlined"
                                            value={dataProps.chippingDateText}
                                        />
                                    </FormItem>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>
            <Divider />
            <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={4} paddingLeft={2} paddingTop={2}>
                <Box marginBottom={2}>
                    <Typography variant="h5">Reakce tísňové linky na zprávy z objektu</Typography>
                </Box>
                <Grid container spacing={{ xs: 0, md: 2 }}>
                    <Grid item xs={12}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={2}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>POPLACH</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={10}>
                                <FormItem>
                                    <TextField
                                        id="name"
                                        fullWidth
                                        aria-readonly
                                        value={ReactionTypeDesc["Alert"]}
                                        label=""
                                        className={classes.readOnly}
                                        multiline
                                        variant="outlined"
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={2}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>PANIKA</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={10}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        aria-readonly
                                        variant="outlined"
                                        multiline
                                        value={ReactionTypeDesc["Panic"]}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={2}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>PORUCHA</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={10}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                        aria-readonly
                                        multiline
                                        value={ReactionTypeDesc["Failure"]}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container spacing={{ xs: 0, md: 0 }} columns={{ xs: 12, sm: 12, md: 12 }}>
                            <Grid item xs={12} md={2}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>ZTRÁTY SPOJENÍ</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={10}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                        aria-readonly
                                        multiline
                                        value={ReactionTypeDesc["ConnectionLost"]}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={4} paddingLeft={2} paddingTop={2}>
                <Grid container spacing={{ xs: 1, md: 2 }}>
                    {dataProps.contactPersonsText.map((personText, index) => (
                        <Grid item xs={12} key={index}>
                            <Grid container spacing={{ xs: 0, md: 0 }}>
                                <Grid item xs={12} md={2}>
                                    <FormItem>
                                        <FormLabel className={classes.formLabelBlock}>Kontaktní osoba {index + 1}</FormLabel>
                                    </FormItem>
                                </Grid>
                                <Grid item xs={12} md={10}>
                                    <FormItem>
                                        <TextField
                                            className={classes.readOnly}
                                            fullWidth
                                            label=""
                                            aria-readonly
                                            variant="outlined"
                                            value={personText}
                                        />
                                    </FormItem>
                                </Grid>
                            </Grid>
                        </Grid>
                    ))}

                    <Grid item xs={12}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Heslo pro komunikaci s tísňonovu linkou</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        aria-readonly
                                        inputProps={{ style: { textTransform: "uppercase" } }}
                                        variant="outlined"
                                        value={dataProps.comunicationPassword}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Uživatelské jméno pro aplikaci MyJABLOTRON</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                        aria-readonly
                                        value={dataProps.appMyJablotronEmail}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Divider />
            <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={4} paddingLeft={2} paddingTop={2}>
                <Box marginBottom={2}>
                    <Typography variant="h5">Fakturační údaje</Typography>
                </Box>
                <Grid container spacing={{ xs: 1, md: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <Grid className={classes.longLabelText} container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Začátek období zdarma</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        id="name"
                                        fullWidth
                                        aria-readonly
                                        value={dataProps.protectionStartText}
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Grid className={classes.longLabelText} container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Konec období zdarma</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        aria-readonly
                                        variant="outlined"
                                        value={dataProps.protectionEndText}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid display={"none"} item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Zájem do budoucna</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                        aria-readonly
                                        value={dataProps.futureServiceText}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}></Grid>
                    {dataProps.personType === "Legal" && (
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={{ xs: 0, md: 0 }}>
                                <Grid item xs={12} md={4}>
                                    <FormItem>
                                        <FormLabel className={classes.formLabelBlock}>IČ</FormLabel>
                                    </FormItem>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <FormItem>
                                        <TextField
                                            fullWidth
                                            label=""
                                            className={classes.readOnly}
                                            aria-readonly
                                            variant="outlined"
                                            value={dataProps.ico}
                                        />
                                    </FormItem>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    <Grid item xs={12} sm={6}>
                        {dataProps.personType === "Legal" && (
                            <Grid container spacing={{ xs: 0, md: 0 }}>
                                <Grid item xs={12} md={4}>
                                    <FormItem>
                                        <FormLabel className={classes.formLabelBlock}>DIČ</FormLabel>
                                    </FormItem>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                    <FormItem>
                                        <TextField
                                            fullWidth
                                            label=""
                                            className={classes.readOnly}
                                            variant="outlined"
                                            aria-readonly
                                            value={dataProps.vat}
                                        />
                                    </FormItem>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={2}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Fakturační adresa</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={10}>
                                <FormItem>
                                    {
                                        <TextField
                                            fullWidth
                                            label=""
                                            className={classes.readOnly}
                                            aria-readonly
                                            variant="outlined"
                                            value={dataProps.invoiceAddressFormatted}
                                        />
                                    }
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Fakturační e-mail</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        aria-readonly
                                        variant="outlined"
                                        value={dataProps.emailInvoice}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={{ xs: 0, md: 0 }}>
                            <Grid item xs={12} md={4}>
                                <FormItem>
                                    <FormLabel className={classes.formLabelBlock}>Kontaktní e-mail</FormLabel>
                                </FormItem>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <FormItem>
                                    <TextField
                                        fullWidth
                                        label=""
                                        className={classes.readOnly}
                                        variant="outlined"
                                        aria-readonly
                                        value={dataProps.emailSendingDocumentation}
                                    />
                                </FormItem>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Divider />
            <Grid container spacing={{ xs: 1, md: 2 }} marginBottom={4}>
                <Grid item xs={12}>
                    <Box marginBottom={2}>
                        <Typography variant="h5">Poznámka</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            multiline
                            value={note}
                            placeholder="V případě, že potřebujete zadat doplňující informace nebo upřesnění, využijte prostor zde"
                            onChange={(e) => handleSetNote(e.target.value)}
                        />
                    </Box>
                </Grid>
            </Grid>

            <Divider />
            <Box className={classes.flex}>
                <Button variant="outlined" onClick={() => onStepBack()}>
                    &#60; Zpět
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => onSubmit()}
                    aria-readonly={isUpdating}
                    startIcon={isUpdating && <CircularProgress size={20} />}
                >
                    Dokončit &#62;
                </Button>
            </Box>
        </Box>
    )
}

export default Step6View
